import React, { memo } from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import RoleTag from 'app/shared/components/loanApplication/RoleTag';
import { ROLE_TYPES } from 'app/shared/components/loanApplication/RoleTag/RoleTag.constants';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';
import { getIsUserActive, getIsUserIdle } from 'utils/presence';

import { UNNAMED_USER_TEXT } from '../../PresenceAvatarGroup.constants';
import {
  getSurplusAvatarStyles,
  getSurplusStatusDotStyles,
  surplusNameStyles,
  surplusRowStyles,
  surplusRowTextStyles,
} from '../../PresenceAvatarGroup.styles';

const PresenceSurplusUser = ({ userData, userColor = null }) => {
  const { firstName, lastName, roleName, presenceData } = userData;
  const isName = !!(firstName && lastName);
  const isPresent = !_.isNil(presenceData);

  return (
    <Box sx={surplusRowStyles}>
      <Avatar sx={getSurplusAvatarStyles({ userColor })}>
        <Typography color="inherit" variant="medium12">
          {getPersonInitials({ firstName, lastName })}
        </Typography>
      </Avatar>
      <Box sx={surplusRowTextStyles}>
        <Typography color="text.primary" sx={surplusNameStyles} variant="medium12">
          {isName ? `${firstName} ${lastName}` : UNNAMED_USER_TEXT}
        </Typography>
        {!_.isNil(roleName) && <RoleTag roleType={ROLE_TYPES.INTERNAL}>{roleName}</RoleTag>}
      </Box>
      <Box
        sx={getSurplusStatusDotStyles({
          isActive: isPresent && getIsUserActive(presenceData),
          isIdle: isPresent && getIsUserIdle(presenceData),
        })}
      />
    </Box>
  );
};

PresenceSurplusUser.propTypes = {
  userData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    roleName: PropTypes.string,
    presenceData: PropTypes.shape({
      status: PropTypes.string,
      connectionId: PropTypes.string,
    }),
  }).isRequired,
  userColor: PropTypes.shape({
    bg: PropTypes.string,
    fg: PropTypes.string,
    dot: PropTypes.string,
  }),
};

export default memo(PresenceSurplusUser);
